import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Bugsnag from '../../utils/bugsnag';
import { FallbackView } from '../FallbackView';
import { setError } from '../../actions';
import ErrorIcon from '../../public/static/images/search/icons/icon-error.svg';
import { RootState } from '../../store/types';
import { ErrorBoundaryProps, ErrorBoundaryState } from './types';

const mapStateToProps = (state: RootState) => ({
  isError: state.errorUI.isError
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setErrorUI: (errorState: boolean) => dispatch(setError(errorState))
});

class ErrorBoundaryClass extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ error, errorInfo });
    Bugsnag.notify(error);
    console.log(`Error: ${error}`, errorInfo);
  }

  componentDidUpdate(prevProps: ErrorBoundaryProps) {
    if (this.props.statusCode !== 500 && prevProps.isError) {
      this.props.setErrorUI(false);
    }
  }

  render() {
    const { i18n, router, isError, statusCode, pageProps } = this.props;
    const { error } = this.state;

    if (error || isError || statusCode === 500) {
      const isRouteSearch =
        pageProps.pathname === '/[...search]' || pageProps.isSearchPage;

      return (
        <FallbackView
          width={50}
          height={50}
          isShowHeader={isRouteSearch}
          text={i18n.t('search.error.text')}
          title={i18n.t('search.error.title')}
          btnText={i18n.t('search.error.link')}
          onClickHandler={() => router.reload()}
          Icon={ErrorIcon}
        />
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorBoundaryClass);
